import React from "react";

import Typography from "@mui/material/Typography"

const SubTitle = ({label="", variant= "h2"}) => {
    return <Typography variant={variant} className="sinistre-h2">
        {label}
    </Typography>
}

export default SubTitle;
